/*
 * SideLocationTypeManagement.jsx
 *
 * Speakers
 * Created by Mahdi Yousefpour on Fri Feb 10 2023 mys Company
 */

import { useEffect, useRef, useState } from 'react'
import { toast } from 'react-hot-toast'

import { localization } from '../../config/localize/localizable'
import { useLocationTypeHooks } from '../../modules/locationType/hooks/useLocationTypeHooks'
import DefaultSelect from '../element/DefaultSelect'
import DoneButton from '../element/DoneButton'
import SimpleActionTableCells from '../element/Table/SimpleActionTableCells'
import SimpleTableCells from '../element/Table/SimpleTableCells'
import SimpleTableHeaders from '../element/Table/SimpleTableHeader'
import DeleteModal from './DeleteMoal'

const SideLocationTypeManagement = ({ sourceId, className }) => {
    //
    //MARK: VARIABLE

    const locationTypeService = useLocationTypeHooks()
    let [typeId, setTypeId] = useState(0)
    let [types, setTypes] = useState([])
    let [items, setItems] = useState([])
    const [showDeleteModal, setShowDeleteModal] = useState(true)
    const [deletedItem, setDeletedItem] = useState({})

    //
    //MARK: METHODS

    // Delete locationTypes
    const handleDelete = (e, item) => {
        setDeletedItem(item)
        setShowDeleteModal(false)
    }

    const handleClick = () => {
        if (sourceId > 0 && typeId > 0)
            if (items.filter((x) => x.typeId === typeId).length === 0)
                locationTypeService.postLocationTypes(
                    { sourceId: sourceId, typeId },
                    {
                        onSuccess: (response) => {
                            if (response.data.result) {
                                getAll()
                            }
                        },
                    }
                )
            else toast.error(localization.error_dataalreadyexistpleaseselectantheer)
    }

    const getAll = () => {
        locationTypeService.getByLocation(
            { sourceId: sourceId, pi: 0, ps: 200 },
            {
                onSuccess: async (response) => {
                    setItems(response.data.results)
                },
                onError: async () => {
                    setItems([])
                },
            }
        )
    }

    useEffect(() => {
        if (sourceId) getAll()
        locationTypeService.get(
            { locationId: sourceId, pi: 0, ps: 1000 },
            {
                onSuccess: async (response) => {
                    setTypes(
                        response.data.results.sort((a, b) => {
                            return a.title.localeCompare(b.title)
                        })
                    )
                },
            }
        )
    }, [sourceId])

    return (
        <>
            <div className={`w-full bg-white p-2 shadow rounded-md ${className}`}>
                <div className="text-sm font-bold mb-1"> {localization.category}</div>
                <hr />
                <div className="p-2">
                    <div className="w-full rounded ">
                        <div className="grid grid-cols-3 py-2">
                            <div className="col-span-2">
                                <DefaultSelect
                                    items={types}
                                    itemCaption="title"
                                    itemValue="id"
                                    onChange={(e) => {
                                        setTypeId(e)
                                    }}
                                />
                            </div>
                            <DoneButton label={localization.add} onClick={handleClick} isDisabled={sourceId === 0 || typeId === 0} className="pr-1" />
                        </div>
                    </div>
                    <div className="w-full rounded shadow ">
                        <table className="w-full p-2 bg-white text-center  rounded">
                            <thead className="h-10  bg-table-header text-xs rounded">
                                <tr>
                                    <SimpleTableHeaders items={[localization.number, localization.title, localization.actions]} />
                                </tr>
                            </thead>
                            <tbody>
                                {items &&
                                    items.map((item, index) => {
                                        return (
                                            <tr className={`text-sm p-8 h-12 hover:bg-orange-50 border-b border-blue-100 ${index % 2 === 0 ? '' : 'bg-gray-50'}`} key={index}>
                                                <SimpleTableCells hints={[item.typeId]} items={[index + 1, item.typeTitle]} />
                                                <SimpleActionTableCells item={item} handleDelete={(e) => handleDelete(e, item)} />
                                            </tr>
                                        )
                                    })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div>
                <DeleteModal
                    visible={showDeleteModal}
                    title={deletedItem.typeTitle}
                    complete={(flag) => {
                        setShowDeleteModal(true)
                        if (flag)
                            locationTypeService.deleteLocationTypes(deletedItem.id, {
                                onSuccess: async (response) => {
                                    getAll()
                                    if (response?.data?.messages?.length > 0) toast.success(response?.data?.messages[0])
                                },
                            })
                        else setDeletedItem({})
                    }}
                />
            </div>
        </>
    )
}

export default SideLocationTypeManagement
